var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocuments = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 72 72",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8,22 L48,22 C49.1045695,22 50,22.8954305 50,24 L50,64 C50,65.1045695 49.1045695,66 48,66 L8,66 C6.8954305,66 6,65.1045695 6,64 L6,24 C6,22.8954305 6.8954305,22 8,22 Z M13,29 L13,59 L43,59 L43,29 L13,29 Z M56,50 L56,43 L59,43 L59,13 L29,13 L29,16 L22,16 L22,8 C22,6.8954305 22.8954305,6 24,6 L64,6 C65.1045695,6 66,6.8954305 66,8 L66,48 C66,49.1045695 65.1045695,50 64,50 L56,50 Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocuments);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/documents.ebfe5a5485385c5adbf67945679c140c.svg";